<template>
  <div style="width: 100%">
    <v-card outlined class="px-3" width="100%">
      <v-container>
        <h4 style="margin-left: -12px;" class="mb-1">Location</h4>
        <v-row no-gutters>
          <v-text-field
            v-model="selectedName"
            type="text"
            label="Location name"
            required
            dense
          ></v-text-field>
        </v-row>
        <v-row no-gutters>
          <v-text-field
            v-model="selectedStreet"
            type="text"
            label="Street address"
            required
            dense
          ></v-text-field>
        </v-row>
        <v-row no-gutters>
          <v-col class="py-0">
            <v-text-field
              v-model="selectedCity"
              type="text"
              label="City"
              required
              dense
            ></v-text-field>
          </v-col>
          <v-col class="py-0" cols="3">
            <v-select
              v-model="selectedState"
              :items="stateAbbreviations"
              label="State"
              required
              dense
            ></v-select>
          </v-col>
          <v-col class="py-0" cols="3">
            <v-text-field
              v-model="selectedZip"
              type="text"
              label="Zip code"
              required
              dense
            ></v-text-field>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </div>
</template>

<script>

    export default {
        name: 'EventsLocationCard',
        props:{
            zip: {
                type: String,
                required: false,
                default: ''
            },
            state: {
                type: String,
                required: false,
                default: 'VA'
            },
            street: {
                type: String,
                required: false,
                default: ''
            },
            city: {
                type: String,
                required: false,
                default: ''
            },
            name: {
                type: String,
                required: false,
                default: ''
            }
        },
        watch: {
            selectedZip (newValue) {
                this.$emit('update:zip', newValue);
            },
            selectedStreet (newValue) {
                this.$emit('update:street', newValue);
            },
            selectedName (newValue) {
                this.$emit('update:name', newValue);
            },
            selectedState (newValue) {
                this.$emit('update:state', newValue);
            },
            selectedCity (newValue) {
                this.$emit('update:city', newValue);
            },
            zip(newValue) {
                this.selectedZip = newValue;
            },
            street(newValue) {
                this.selectedStreet = newValue;
            },
            name(newValue) {
                this.selectedName = newValue;
            },
            state(newValue) {
                this.selectedState = newValue;
            },
            state(newValue) {
                this.selectedCity = newValue;
            },
        },
        data() {
            return {
                selectedStreet: this.street,
                selectedName: this.name,
                selectedZip: this.zip,
                selectedState: this.state,
                selectedCity: this.city,
                stateAbbreviations: ['AL', 'AK', 'AS', 'AZ', 'AR', 'CA', 'CO',
                    'CT', 'DE', 'DC', 'FM', 'FL', 'GA', 'GU', 'HI', 'ID', 'IL',
                    'IN', 'IA', 'KS', 'KY', 'LA', 'ME', 'MH', 'MD', 'MA', 'MI',
                    'MN', 'MS', 'MO', 'MT', 'NE', 'NV', 'NH', 'NJ', 'NM', 'NY',
                    'NC', 'ND', 'MP', 'OH', 'OK', 'OR', 'PW', 'PA', 'PR', 'RI',
                    'SC', 'SD', 'TN', 'TX', 'UT', 'VT', 'VI', 'VA', 'WA', 'WV',
                    'WI', 'WY']
            }
        }
    }
</script>
<style>
</style>
